<template>
  <div class="better">
    <!--LIST-->
    <q-virtual-scroll
      ref="virtualList"
      class="better-virtual"
      :scroll-target="target"
      :items="scrollData"
      :virtual-scroll-item-size="10"
    >
      <template #default="{ item: it, index: idx }">
        <div
          :key="idx"
          v-ripple
          v-intersection="onIntersection"
          :cate-id="it.id"
          :next-id="it.nextId"
          :pre-id="it.preId"
          :cate-index="it.cateIndex"
          class="list-item"
          clickable
          @click="onClickCard(idx)"
        >
          <div v-if="it.preElId != it.id" bold class="item-cate">
            {{ it.name }}
          </div>
          <ProductCard v-if="!!it.product" :product="it.product" :cart-count="cartCount" />
          <FakeItem v-else />
        </div>
      </template>
    </q-virtual-scroll>
  </div>
</template>

<script>
import { getProdsByCateId } from 'src/api/list.js';
import { mapState } from 'vuex';
import _ from 'lodash';
import { PRODUCT_DETAIL_INVALID } from 'src/utils/config';
import { sticky } from '../utils';
import ProductCard from './ProductCard.vue';
import FakeItem from './FakeItem.vue';

export default {
  name: 'BetterScroll',
  components: { ProductCard, FakeItem },
  directives: { sticky }, // eslint-disable-next-line vue/require-prop-types
  props: ['target', 'cartCount'],
  data() {
    return {
      isReady: false,
      loadedCateIds: {},
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.prefetch.categories || [],
    }),
    scrollData() {
      const { categories } = this;
      const result = categories.reduce(
        ([values, n], it, index, arr) => {
          const isLoaded = it.products && it.products?.length > 0;
          const { id, name, count } = it;
          const nextId = arr[index + 1]?.id;
          const preId = arr[index - 1]?.id;
          const cateIndex = index;
          for (let i = 0; i < it.count; i += 1) {
            const preElId = values[values.length - 1]?.id || null;
            values.push({
              start: i === 0 || i === it.count - 1 ? n : null,
              product: isLoaded ? it.products[i] : null,
              id,
              name,
              count,
              nextId,
              preId,
              cateIndex,
              preElId,
            });
          }
          return [values, n + it.count];
        },
        [[], 0],
      );
      return result[0];
    },
  },
  mounted() {
    this.isReady = true;
    // 监听在进入无效的商品详情后，在列表中删除这个商品
    this.$bus.$on(PRODUCT_DETAIL_INVALID, (product) => {
      this.$store.commit('prefetch/removeInvalidProductInCategory', product);
    });
  },
  beforeDestroy() {
    this.$bus.$off(PRODUCT_DETAIL_INVALID);
  },
  methods: {
    scrollTo(cateId) {
      const index = this.scrollData.findIndex((it) => it?.id === cateId);
      if (index === -1) return;
      this.$refs.virtualList.scrollTo(index, 'center-force');
    },
    async fetchWithCateId(id) {
      if (!id) return;
      for (let i = 0; i < this.categories?.length || 0; i += 1) {
        const it = this.categories[i];
        if (it?.id === id) {
          if (Array.isArray(it.products)) this.loadedCateIds[id] = true;
        }
      }
      if (this.loadedCateIds[id]) return;
      this.loadedCateIds[id] = true;
      const { data } = await getProdsByCateId(id);
      this.updateCategories(data);
    },
    onIntersection(entry) {
      if (entry.isIntersecting) {
        const cateId = entry.target.getAttribute('cate-id');
        const nextId = entry.target.getAttribute('next-id');
        const preId = entry.target.getAttribute('pre-id');
        const cateIndex = entry.target.getAttribute('cate-index');
        this.fetchWithCateId(cateId);
        this.fetchWithCateId(nextId);
        this.fetchWithCateId(preId);
        this.$emit('onTap', cateIndex);
      }
    },
    updateCategories(data) {
      this.cacheCategories = (this.cacheCategories || []).concat([data]);
      clearTimeout(this.cacheTimer);
      this.cacheTimer = null;
      this.cacheTimer = setTimeout(() => {
        const categories = this.categories.map((cate) => {
          this.cacheCategories.forEach((dataItem) => {
            if (cate?.id === dataItem?.id) {
              cate.products = dataItem.products;
            }
          });
          return cate;
        });
        this.$store.commit('prefetch/updateCategories', categories);
        this.cacheCategories = [];
      }, 500);
    },
    onClickCard(idx) {
      if (!process.env.SERVER) {
        sessionStorage.setItem('LIST_INDEX', idx);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.better {
  width: 100%;
  font-family: GothamOffice;
  display: flex;
  flex-direction: column;
  &-virtual {
    padding-bottom: 50px;
    background: $grayBg;
    flex: 1;
    overflow: auto;
    padding-bottom: 68px;
    .list-item {
      position: relative;
    }
    .item-cate {
      height: 40px;
      border-bottom: solid 1px $border-lg;
      line-height: 40px;
      padding: 0 12px;
      font-size: 16px;
      background: #fff;
      margin-top: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
